module.exports = __webpack_public_path__ + "static/media/Logo.3e6cd3b0.svg";